module.exports = __webpack_public_path__ + "img/climate-control.dbd4d80.svg";